<template>
    <div style="width: 100%;height: auto;">
        <div class="gzdt_children">
            <!-- 标签页切换 -->
            <div class="tab-container">
                <div class="tab" :class="{ active: activeTab === 'history' }" @click="switchTab('history')">文史资料</div>
                <div class="tab" :class="{ active: activeTab === 'books' }" @click="switchTab('books')">图书阅览</div>
            </div>
            
            <!-- 文史资料列表 -->
            <div class="gzdt_list_par" v-show="activeTab === 'history'">
                <div class="zwsj" v-if="gzdtList.length==0 &&loading">
                    <van-empty description="暂无数据"/>
                </div>
                <div v-if="gzdtList.length==0 &&!loading" class="jzz">
                    <van-loading type="spinner" />
                </div>
                <div class="gzdt_list_par_div">
                    <div class="gzdt_view" @click="getView(item, 'history')" :class="index<(gzdtList.length-1)?'jgx'+(parseInt((index+1)%5)):''" v-for="(item,index) in gzdtList" :key="index">
                        <div>{{ item.title }}</div>
                        <div>{{item.wzrq}}</div>
                    </div>
                </div>
                <div class="page">
                    <div class="pagePar">
                        <div class="pageLeft">共{{ historyPage.total }}条记录/共{{ historyPage.totalPage }}页</div>
                        <div class="pageCenter">
                            <button @click="setHistoryPageNo(historyPage.pageNo-1)" :disabled="historyPage.pageNo==1" :class="historyPage.pageNo>1?'clickTrue nextPage':'clickFalse nextPage'">上一页</button>
                            <div v-if="historyPage.pageNo-5>=1">...</div>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo-4)" v-if="historyPage.pageNo-4>=1">{{ historyPage.pageNo-4 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo-3)" v-if="historyPage.pageNo-3>=1">{{ historyPage.pageNo-3 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo-2)" v-if="historyPage.pageNo-2>=1">{{ historyPage.pageNo-2 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo-1)" v-if="historyPage.pageNo-1>=1">{{ historyPage.pageNo-1 }}</button>
                            <button class="xzxg">{{ historyPage.pageNo }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo+1)" v-if="historyPage.pageNo+1<=historyPage.totalPage">{{ historyPage.pageNo+1 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo+2)" v-if="historyPage.pageNo+2<=historyPage.totalPage">{{ historyPage.pageNo+2 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo+3)" v-if="historyPage.pageNo+3<=historyPage.totalPage">{{ historyPage.pageNo+3 }}</button>
                            <button class="wxzxg" @click="setHistoryPageNo(historyPage.pageNo+4)" v-if="historyPage.pageNo+4<=historyPage.totalPage">{{ historyPage.pageNo+4 }}</button>
                            <div v-if="historyPage.pageNo+5<=historyPage.totalPage">...</div>
                            <button @click="setHistoryPageNo(historyPage.pageNo+1)" :disabled="historyPage.pageNo>=historyPage.totalPage" :class="historyPage.pageNo<historyPage.totalPage?'clickTrue nextPage':'clickFalse nextPage'">下一页</button>
                        </div>

                        <div class="pageRight">跳转到 <input class="sdtz" type="number" @change="loadHistoryDataTz" /> 页</div>
                    </div>
                </div>
            </div>
            
            <!-- 图书阅览列表 -->
            <div class="gzdt_list_par" v-show="activeTab === 'books'">
                <div class="zwsj" v-if="booksList.length==0 &&booksLoading">
                    <van-empty description="暂无数据"/>
                </div>
                <div v-if="booksList.length==0 &&!booksLoading" class="jzz">
                    <van-loading type="spinner" />
                </div>
                <div class="gzdt_list_par_div">
                    <div class="gzdt_view" @click="getPdfView(item)" :class="index<(booksList.length-1)?'jgx'+(parseInt((index+1)%5)):''" v-for="(item,index) in booksList" :key="index">
                        <div>{{ item.name }}</div>
                        <div style="display: flex; justify-content: flex-end;">
                            <span style="margin-right: 130px;color: #999999;">浏览{{ item.llcs || 0 }}次</span>
                            <span>{{item.createTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="page">
                    <div class="pagePar">
                        <div class="pageLeft">共{{ booksPage.total }}条记录/共{{ booksPage.totalPage }}页</div>
                        <div class="pageCenter">
                            <button @click="setBooksPageNo(booksPage.pageNo-1)" :disabled="booksPage.pageNo==1" :class="booksPage.pageNo>1?'clickTrue nextPage':'clickFalse nextPage'">上一页</button>
                            <div v-if="booksPage.pageNo-5>=1">...</div>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo-4)" v-if="booksPage.pageNo-4>=1">{{ booksPage.pageNo-4 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo-3)" v-if="booksPage.pageNo-3>=1">{{ booksPage.pageNo-3 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo-2)" v-if="booksPage.pageNo-2>=1">{{ booksPage.pageNo-2 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo-1)" v-if="booksPage.pageNo-1>=1">{{ booksPage.pageNo-1 }}</button>
                            <button class="xzxg">{{ booksPage.pageNo }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo+1)" v-if="booksPage.pageNo+1<=booksPage.totalPage">{{ booksPage.pageNo+1 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo+2)" v-if="booksPage.pageNo+2<=booksPage.totalPage">{{ booksPage.pageNo+2 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo+3)" v-if="booksPage.pageNo+3<=booksPage.totalPage">{{ booksPage.pageNo+3 }}</button>
                            <button class="wxzxg" @click="setBooksPageNo(booksPage.pageNo+4)" v-if="booksPage.pageNo+4<=booksPage.totalPage">{{ booksPage.pageNo+4 }}</button>
                            <div v-if="booksPage.pageNo+5<=booksPage.totalPage">...</div>
                            <button @click="setBooksPageNo(booksPage.pageNo+1)" :disabled="booksPage.pageNo>=booksPage.totalPage" :class="booksPage.pageNo<booksPage.totalPage?'clickTrue nextPage':'clickFalse nextPage'">下一页</button>
                        </div>

                        <div class="pageRight">跳转到 <input class="sdtz" type="number" @change="loadBooksDataTz" /> 页</div>
                    </div>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: "sqmy",
    data(){
      return{
        // 标签页状态
        activeTab: 'history',
        
        // 文史资料数据
        gzdtList:[],
        historyPage:{
            pageSiz:20,
            pageNo:1,
            total:0,
            totalPage:1
        },
        loading: false,
        
        // 图书阅览数据
        booksList:[],
        booksPage:{
            pageSiz:20,
            pageNo:1,
            total:0,
            totalPage:1
        },
        booksLoading: false,
        
        objectView:{}
      }
    },
    created(){
        this.loadHistoryData(1);
        // 初始化时也加载图书数据，避免切换时等待
        this.loadBooksData(1);
    },
    methods:{
        // 切换标签页
        switchTab(tab){
            this.activeTab = tab;
        },
        
        // 文史资料相关方法
        loadHistoryDataTz(pageNo){
            if(pageNo.target.value>=1){
                if(pageNo.target.value && pageNo.target.value<=this.historyPage.totalPage){
                    this.loadHistoryData(pageNo.target.value)
                }else{
                    pageNo.target.value = this.historyPage.totalPage;
                    this.loadHistoryData(this.historyPage.totalPage)
                }
            }else{
                pageNo.target.value = "";
            }
        },
        
        setHistoryPageNo(pageNo){
            this.loadHistoryData(pageNo);
        }, 
        
        loadHistoryData(pageNo){
            this.loading = false
            httpAction("/zxwz/zxwzwzdh/page?type=08&pageNo="+pageNo+"&pageSize=20&sffb=1&shzt=02",{},'get').then((res)=>{
                this.loading = true
                if(res.success){
                    this.gzdtList = res.result.records;
                    console.log("history result:", res.result)
                    this.historyPage.total = res.result.total;
                    this.historyPage.pageNo = parseInt(pageNo);
                    this.historyPage.totalPage = res.result.pages;
                }else{
                    this.$message.warning(res.message);
                }
            })
        },
        
        // 图书阅览相关方法
        loadBooksDataTz(pageNo){
            if(pageNo.target.value>=1){
                if(pageNo.target.value && pageNo.target.value<=this.booksPage.totalPage){
                    this.loadBooksData(pageNo.target.value)
                }else{
                    pageNo.target.value = this.booksPage.totalPage;
                    this.loadBooksData(this.booksPage.totalPage)
                }
            }else{
                pageNo.target.value = "";
            }
        },
        
        setBooksPageNo(pageNo){
            this.loadBooksData(pageNo);
        },
        
        loadBooksData(pageNo){
            this.booksLoading = false
            // 这里假设图书阅览的接口参数类似，type可能为其他值，需要根据实际情况调整
            httpAction("/zxwz/zxwztsgl/page?pageNo="+pageNo+"&pageSize=20",{},'get').then((res)=>{
                this.booksLoading = true
                if(res.success){
                    this.booksList = res.result.records;
                    console.log("books result:", res.result)
                    this.booksPage.total = res.result.total;
                    this.booksPage.pageNo = parseInt(pageNo);
                    this.booksPage.totalPage = res.result.pages;
                }else{
                    this.$message.warning(res.message);
                }
            })
        },
        
        // 查看详情
        getView(item, type){
            this.$router.push({
                path:"/viewSearch",
                query:{
                    id: item.id,
                    type: type // 可以传递类型信息，方便详情页处理
                }
            })
        },
        // 查看详情
        getPdfView(item){
            httpAction("/zxwz/zxwztsgl/add/ydl/id?id="+item.id,{},'get').then((res)=>{
                if(!res.success){
                    this.$message.warning(res.message);
                }
            })
            this.$router.push({
                path:"/pdfView",
                query:{
                    id: item.id
                }
            })
        }
    }
  }
</script>

<style scoped lang="less">
.gzdt_children{
  width: 100%;
  height: auto;
  margin: auto;
  position: relative;
  padding-top: 40px;
  
  // 标签页样式
  .tab-container {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 2px solid #2966AE;
    
    .tab {
      padding: 10px 30px;
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 24px;
      color: #666666;
      cursor: pointer;
      transition: all 0.3s ease;
      border-bottom: 3px solid transparent;
      margin-bottom: -2px; // 覆盖底部边框
      
      &.active {
        color: #1461BD;
        border-bottom-color: #2966AE;
      }
      
      &:hover {
        color: #1461BD;
      }
    }
  }
  
  p{
    // 原有样式保留，但现在应该不会显示了
    display: none;
  }

  .gzdt_list_par{
    width: 100%;
    height: 1000px;

    .page{
        height: 60px;
        background: #F7F7F7;
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .gzdt_list_par_div{
        display: flex;
        flex-direction: column;
        height: 830px;
        width: 96%;
        padding-left: 20px;

      .gzdt_view{
        height: 40px;
        align-items: center;
        display: flex;
        position: relative;
        cursor: pointer;

        :nth-child(1){
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 85%;

          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
        }
        :nth-child(2){
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: absolute;
          right: 0;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          text-align: center;
        }

        ::after{
          position: absolute;
          content: "";
          width: 4px;
          height: 4px;
          background: #999999;
          border-radius: 4px;
          left: -15px;
          top: 46%;
        }
      }
    }
  }
}

.jgx0{
    margin-bottom: 20px;
    position: relative;
    
}

.jgx0:after{
    content: "";
    position: absolute;
    width: 105%;
    height: 1px;
    left: 50%;
    transform: translate(-50%,0);
    background: #EBEBEB;
    bottom: -10px;
}

button{
    cursor: pointer;
}

.xzxg{
    width: 32px;
    height: 32px;
    background: #2C75DF;
    border: 1px solid #2966AE;
    border-radius: 3px;
    color: #fff;
    
}   
.wxzxg{
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D3D3D3;
    border-radius: 3px;
}


.nextPage{
    width: 70px;
    height: 32px;
    border: 1px solid #BFBFBF;
    border-radius: 3px;
}

.clickTrue{
    background: #fff !important;
}

.clickFalse{
    background: #E1E1E1;
}

.clickTrue:hover,.wxzxg:hover{ 
    background: #2c75df90 !important;
    color: #fff;
}

.pagePar{
    width: 80%;
    display: flex;
    align-items: center;
}

.pageLeft{
    margin: auto;
}
.pageCenter{
    margin: auto;
    display: flex;
    justify-content: center;
    button{
        margin: auto 3px;
    }
}
.pageRight{
    margin: auto;
}

.sdtz{
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D3D3D3;
    border-radius: 3px;
    padding: 0 5px;
    outline: none;
}

section{
  min-height: 588px;
}
</style>